import { AuditPage } from 'features/audit';

export const TechOperatorAuditPage: React.FC = () => <AuditPage />;
